import { render, staticRenderFns } from "./RegistersView.vue?vue&type=template&id=12a2c1da"
import script from "./RegistersView.vue?vue&type=script&lang=js"
export * from "./RegistersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports